import React, { useState, useContext, useEffect, useRef, useCallback } from "react";
import { AuthContext } from "../context/AuthContext";
import plutonicLogo from "../assets/images/plutonicLogo.svg";
import plutonicName from "../assets/images/plutonicName.svg";
import NicknameForm from "./NicknameForm";
import "../styles/globals.css";
import { Link, useLocation } from "react-router-dom";
import ContactModal from "./ContactModal";
import RequirementsModal from "./RequirementsModal";

const Navbar = () => {
  const location = useLocation();
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [dropdownVisible, setDropdownVisible] = useState(false);
  const [editNicknameVisible, setEditNicknameVisible] = useState(false);
  const [contactVisible, setContactVisible] = useState(false);
  const [requirementsVisible, setRequirementsVisible] = useState(false);
  const dropdownRef = useRef(null);
  const {
    userType,
    currentNickname,
    setCurrentNickname,
    handleLogout,
    PlutonicuserID,
    email,
    setCurrentFormType,
  } = useContext(AuthContext);


  useEffect(() => {
    setIsLoggedIn(!!currentNickname);
  }, [currentNickname]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setDropdownVisible(false);
      }
    };

    if (dropdownVisible) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [dropdownVisible]);

  const updateNickname = (newNickname) => {
    setCurrentNickname(newNickname);
    localStorage.setItem("currentNickname", newNickname);
    setEditNicknameVisible(false);
  };

  const toggleDropdown = () => {
    setDropdownVisible(!dropdownVisible);
  };

  const onLogout = () => {
    handleLogout();
    setCurrentFormType("login");
    localStorage.clear();
    setDropdownVisible(false);
  };

  const handleEditNickname = () => {
    setEditNicknameVisible(true);
    setDropdownVisible(false);
  };

  const openContactForm = () => {
    setContactVisible(true);
    setDropdownVisible(false);
  };

  const closeContactForm = useCallback(() => {
    setContactVisible(false);
  }, []);

  const isClient = ["client", "client-ai-companion", "client-ai-enabled-therapy", "client-ai-therapy"].includes(
    userType?.toLowerCase()
  );
  const openRequirements = () => {
    setRequirementsVisible(true);
    setDropdownVisible(false);
  };
  const closeRequirements = useCallback(() => setRequirementsVisible(false), []);

  return (
    <nav className="flex justify-between items-center bg-[#D8F8FF] p-12 w-full h-[83px] fixed top-0 left-0 z-50">
      <div className="flex items-center space-x-4">
        <Link
          to={"/"}
          className="flex items-center hover:scale-105 transition-transform duration-300"
        >
          <img
            src={plutonicLogo}
            alt="Plutonic Logo"
            className="w-[60px] h-[35px] sm:w-[70px] sm:h-[40px] md:w-[80px] md:h-[45px] lg:w-[90px] lg:h-[50px] mr-4 hover:opacity-80 transition-opacity duration-300"
          />
          <img
            src={plutonicName}
            alt="company name"
            className="w-[100px] h-[20px] sm:w-[110px] sm:h-[25px] md:w-[130px] md:h-[30px] lg:w-[150px] lg:h-[35px] hover:opacity-80 transition-opacity duration-300"
          />
        </Link>

        {/* {isLoggedIn && (
          <button className="ml-4 py-2 px-6 border-[#22AAEE] text-black font-semibold rounded-full hover:text-[#22AAEE] transition">
            Your Therapist
          </button>
        )} */}
      </div>

      {/* {!isLoggedIn && (
      <div className="absolute left-1/2 transform -translate-x-1/2 text-2xl font-semibold  text-black">
        Therapy Built for You
      </div>
    )} */}

      {!isLoggedIn && !location.pathname.startsWith("/admin") && (
        <div className="absolute left-1/2 transform -translate-x-1/2 text-2xl font-semibold text-black hidden lg:block">
          AI Powered Mental Health Support
        </div>
      )}
      {/* User Section */}
      <div className="flex items-center space-x-4">
        {isLoggedIn ? (
          <>
            {/* <button
              className="py-2 px-6 border-[#22AAEE] text-black  font-semibold rounded-full hover:text-[#22AAEE] transition"
              onClick={() => window.open('https://readyplayer.me/signin', '_blank')}
            >
              Your Avatar
            </button> */}
            <div className="relative" ref={dropdownRef}>
              <div
                className="inline-flex items-center font-semibold space-x-2 py-2 px-4 border bg-white border-[#22AAEE] hover:bg-[#22AAEE] hover:text-white text-black rounded-full cursor-pointer shadow-lg"
                onClick={toggleDropdown}
              >
                <span>{currentNickname || "USER"}</span>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                  className={`w-4 h-4 transition-transform duration-200 ${
                    dropdownVisible ? 'rotate-180' : ''
                  }`}
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M19 9l-7 7-7-7"
                  />
                </svg>
              </div>

              {dropdownVisible && (
                <div className="absolute right-0 mt-2 w-48 bg-white shadow-lg rounded-lg z-50">
                  <ul className="py-2 font-semibold">
                    <li
                      className="px-4 py-2 hover:bg-gray-200 cursor-pointer"
                      onClick={handleEditNickname}
                    >
                      Edit Nickname
                    </li>
                    <li className="px-4 py-2 hover:bg-gray-200 cursor-pointer">
                      <Link
                        to="/unity-room/demo"
                        onClick={() => {
                          const userId = localStorage.getItem("PlutonicuserID");

                          const meetingID = `demo-${crypto.randomUUID()}`;
                          sessionStorage.setItem("meetingID", meetingID);
                          sessionStorage.setItem("userId", userId);
                        }}
                      >
                        Demo Space
                      </Link>
                    </li>
                    <li className="px-4 py-2 hover:bg-gray-200 cursor-pointer">
                      <a href="https://billing.stripe.com/p/login/cNidR8etk0708KXfUH9k400">
                        Billing
                      </a>
                    </li>

                    {isClient && (
                      <li>
                        <button
                          type="button"
                          onClick={openRequirements}
                          className="w-full px-4 py-2 text-left whitespace-nowrap hover:bg-gray-200"
                        >
                          Requirements
                        </button>
                      </li>
                    )}
                    <li>
                      <button
                        type="button"
                        onClick={openContactForm}
                        className="w-full px-4 py-2 text-left hover:bg-gray-200"
                      >
                        Contact Us
                      </button>
                    </li>

                    <li
                      className="px-4 py-2 hover:bg-gray-200 cursor-pointer"
                      onClick={onLogout}
                    >
                      Logout
                    </li>
                  </ul>
                </div>
              )}
            </div>
          </>
        ) : (
          <Link
            to="/login"
            className="py-2 px-6 border border-[#22AAEE] text-black font-semibold rounded-full inline-block text-center"
          >
            Login
          </Link>
        )}
      </div>

      {editNicknameVisible && (
        <div className="absolute top-[100px] left-1/2 transform -translate-x-1/2 z-50">
          <NicknameForm
            currentNickname={currentNickname}
            setCurrentNickname={updateNickname}
            onNicknameSubmit={() => {
              setEditNicknameVisible(false);
            }}
            PlutonicuserID={PlutonicuserID}
            onClose={() => setEditNicknameVisible(false)}
          />
        </div>
      )}
      <RequirementsModal
        isOpen={isLoggedIn && isClient && requirementsVisible}
        onClose={closeRequirements}
      />
      <ContactModal
        isOpen={contactVisible}
        onClose={closeContactForm}
        defaultEmail={email}
      />
    </nav>
  );
};

export default Navbar;

// works, go back

// import React, { useState, useEffect, useRef } from "react";
// import plutonicLogo from "../assets/images/plutonicLogo.svg";
// import plutonicName from "../assets/images/plutonicName.svg";
// import mentalhealth from "../assets/images/mentalhealth.png";
// import plutonic from "../assets/images/plutonic.png";
// import NicknameForm from "./NicknameForm";
// import "../styles/globals.css";
// import { Link } from "react-router-dom";
// import axios from "axios";

// const Navbar = ({
//   currentNickname,
//   handleLogout,
//   setFormType,
//   showButtons,
//   PlutonicuserID,
//   setCurrentNickname,
//   navbarBanner
// }) => {
//   const [isLoggedIn, setIsLoggedIn] = useState(false);
//   const [dropdownVisible, setDropdownVisible] = useState(false);
//   const [editNicknameVisible, setEditNicknameVisible] = useState(false);
//   const [hasDemoAccess, setHasDemoAccess] = useState(false);

//   useEffect(() => {
//     // console.log('[Navbar] Received PlutonicuserID:', PlutonicuserID);
//   }, [PlutonicuserID]);

//   useEffect(() => {
//     // console.log('[Navbar] Current Nickname in Navbar:', currentNickname);
//     setIsLoggedIn(!!currentNickname);
//   }, [currentNickname]);

//   useEffect(() => {
//     const checkDemoAccess = async () => {
//       const userId = PlutonicuserID || localStorage.getItem("PlutonicuserID");
//       if (!userId) return;

//       try {
//         const response = await axios.get(
//           `${process.env.REACT_APP_PYTHON_API_URL}/api/GetMeetings/${userId}`,
//           {
//             headers: {
//               "Cache-Control": "no-cache",
//               Pragma: "no-cache",
//               Expires: "0",
//             },
//             params: { t: new Date().getTime() }, // Cache-busting
//           }
//         );

//         const meetings = response.data;
//         const hasAccess = meetings.some(
//           (meeting) =>
//             meeting.PlutonicuserID.includes(userId) &&
//             meeting.demoaccess === true
//         );

//         setHasDemoAccess(hasAccess);
//       } catch (error) {
//         console.error("[Navbar] Failed to fetch demo access:", error);
//         setHasDemoAccess(false);
//       }
//     };

//     checkDemoAccess();
//   }, [PlutonicuserID]);

//   const updateNickname = (newNickname) => {
//     // console.log('[Navbar] Updating Nickname to:', newNickname);
//     setCurrentNickname(newNickname);
//     localStorage.setItem("currentNickname", newNickname);
//     setEditNicknameVisible(false);
//   };

//   const toggleDropdown = () => {
//     setDropdownVisible(!dropdownVisible);
//   };

//   const onLogout = () => {
//     // console.log('[Navbar] Logging out...');
//     handleLogout();
//     setFormType("login");
//     localStorage.clear();
//   };

//   const handleEditNickname = () => {
//     // console.log('[Navbar] Opening Nickname Form...');
//     setEditNicknameVisible(true);
//     setDropdownVisible(false);
//   };

//   return (
//     <nav className="flex justify-between items-center bg-[#209424] p-12 w-full h-[83px] fixed top-0 left-0 z-50">
//       {/* Logo Section */}
//       <div className="flex items-center space-x-4">
//         <Link
//           to={isLoggedIn ? "/therapy-rooms" : "/"}
//           className="flex items-center hover:scale-105 transition-transform duration-300"
//         >
//           {/* <img
//             src={plutonicLogo}
//             alt="Plutonic Logo"
//             className="w-[60px] h-[35px] sm:w-[70px] sm:h-[40px] md:w-[80px] md:h-[45px] lg:w-[90px] lg:h-[50px] mr-4 hover:opacity-80 transition-opacity duration-300"
//           /> */}
//           {/* <img
//             src={plutonicName}
//             alt="company name"
//             className="w-[100px] h-[20px] sm:w-[110px] sm:h-[25px] md:w-[130px] md:h-[30px] lg:w-[150px] lg:h-[35px] hover:opacity-80 transition-opacity duration-300"
//           /> */}
//           <img
//   src={plutonic}
//   alt="company name"
//   className="w-[250px] h-[55px] object-contain hover:opacity-80 transition-opacity duration-300"
// />

//         </Link>

//         {/* {isLoggedIn && (
//           <button className="ml-4 py-2 px-6 border-[#22AAEE] text-black font-semibold rounded-full hover:text-[#22AAEE] transition">
//             Your Therapist
//           </button>
//         )} */}
//       </div>

//       {/* {!isLoggedIn && (
//       <div className="absolute left-1/2 transform -translate-x-1/2 text-2xl font-semibold  text-black">
//         Therapy Built for You
//       </div>
//     )} */}

//       {/* {!isLoggedIn && (
//         <div className="absolute left-1/2 transform -translate-x-1/2 text-2xl font-semibold text-black hidden lg:block">
//           Therapy Built for You
//         </div>
//       )} */}

// {!isLoggedIn && (
//   <div className="absolute left-1/2 transform -translate-x-1/2 hidden lg:flex items-center space-x-2 text-xl font-semibold text-white">
//     <img
//             src={mentalhealth}
//             alt="company name"
//             className="w-[100px] h-[20px] sm:w-[110px] sm:h-[25px] md:w-[130px] md:h-[30px] lg:w-[100px] lg:h-[50px] hover:opacity-80 transition-opacity duration-300"
//           />
//     <span>Breaking the Stigma. This Month, Let's Talk About It.</span>
//   </div>
// )}

// {navbarBanner && (
//   <div className="absolute left-1/2 transform -translate-x-1/2 hidden lg:flex items-center space-x-2 text-xl font-semibold text-white">
//     <img
//       src={mentalhealth} // Make sure this is imported at the top
//       alt="Awareness Icon"
//       className="w-[100px] h-[20px] sm:w-[110px] sm:h-[25px] md:w-[130px] md:h-[30px] lg:w-[100px] lg:h-[50px] hover:opacity-80 transition-opacity duration-300" // You can tweak size if needed
//     />
//     <span className="whitespace-nowrap">
//       {navbarBanner}
//     </span>
//   </div>
// )}

//       {/* User Section */}
//       <div className="flex items-center space-x-4">
//         {isLoggedIn ? (
//           <>
//             {/* <button
//               className="py-2 px-6 border-[#22AAEE] text-black  font-semibold rounded-full hover:text-[#22AAEE] transition"
//               onClick={() => window.open('https://readyplayer.me/signin', '_blank')}
//             >
//               Your Avatar
//             </button> */}
//             <div className="relative">
//               <div
//                 className="inline-flex items-center font-semibold space-x-2 py-2 px-4 border bg-white border-[#22AAEE] hover:bg-[#22AAEE] hover:text-white text-black rounded-full cursor-pointer shadow-lg"
//                 onClick={toggleDropdown}
//               >
//                 <span>{currentNickname || "USER"}</span>
//                 <svg
//                   xmlns="http://www.w3.org/2000/svg"
//                   fill="none"
//                   viewBox="0 0 24 24"
//                   stroke="currentColor"
//                   className="w-4 h-4"
//                 >
//                   <path
//                     strokeLinecap="round"
//                     strokeLinejoin="round"
//                     strokeWidth="2"
//                     d="M19 9l-7 7-7-7"
//                   />
//                 </svg>
//               </div>

//               {dropdownVisible && (
//                 <div className="absolute right-0 mt-2 w-48 bg-white shadow-lg rounded-lg z-50">
//                   <ul className="py-2 font-semibold">
//                     <li
//                       className="px-4 py-2 hover:bg-gray-200 cursor-pointer"
//                       onClick={handleEditNickname}
//                     >
//                       Edit Nickname
//                     </li>
//                     <li
//                       className={`px-4 py-2 ${
//                         hasDemoAccess
//                           ? "hover:bg-gray-200 cursor-pointer"
//                           : "text-gray-400 cursor-not-allowed"
//                       }`}
//                     >
//                       {hasDemoAccess ? (
//                         <Link to="/demo-beach">Demo Space</Link>
//                       ) : (
//                         <span>Demo Space</span>
//                       )}
//                     </li>

//                     <li className="px-4 py-2 hover:bg-gray-200 cursor-pointer">
//                       <a href="mailto:Help@plutonic.co">Contact Us</a>
//                     </li>
//                     <li
//                       className="px-4 py-2 hover:bg-gray-200 cursor-pointer"
//                       onClick={onLogout}
//                     >
//                       Logout
//                     </li>
//                   </ul>
//                 </div>
//               )}
//             </div>
//           </>
//         ) : (
//           <button
//             className="py-2 px-6 border border-[#22AAEE] text-white font-semibold rounded-full"
//             onClick={() => setFormType("login")}
//           >
//             Login
//           </button>
//         )}
//       </div>

//       {editNicknameVisible && (
//         <div className="absolute top-[100px] left-1/2 transform -translate-x-1/2 z-50">
//           <NicknameForm
//             currentNickname={currentNickname}
//             setCurrentNickname={updateNickname}
//             onNicknameSubmit={() => {
//               // console.log('[Navbar] Nickname Form Submitted.');
//               setEditNicknameVisible(false);
//             }}
//             PlutonicuserID={PlutonicuserID}
//             onClose={() => setEditNicknameVisible(false)}
//           />
//         </div>
//       )}
//     </nav>

//   );
// };

// export default Navbar;
